










































import Vue from 'vue';
/* globals process */
import { EventBus } from '@/event-bus';
import { AuthService } from '@/services';

interface Data {
  value: number;
  interval: any;
  loading: boolean;
  enterDelay: number;
  exitDelay: number;
  animationSpeed: number;
  initialLoad: boolean;
  errorLoading: boolean;
  loadingEvent: boolean;
  error: any;
  clientName: string;
}

export default Vue.extend({
  name: 'PageLoadIndicator',
  data() {
    return {
      value: 0,
      interval: {},
      loading: false,
      enterDelay: 250,
      exitDelay: 500,
      animationSpeed: 175,
      initialLoad: true,
      errorLoading: false,
      loadingEvent: false,
      error: null,
      clientName: process.env.VUE_APP_CLIENT_NAME,
    };
  },
  mounted() {
    EventBus.$on('pageLoadStart', () => {
      this.loadingEvent = true;
      this.turnOnIndicator();
    });
    EventBus.$on('pageLoadFinish', () => {
      this.loadingEvent = false;
      this.turnOffIndicator();
    });
    EventBus.$on('initialLoadDone', this.initialLoadDone);
    EventBus.$on('errorLoading', this.displayLoadingError);
  },
  methods: {
    turnOnIndicator(): void {
      if (!this.loading && !this.initialLoad) {
        this.value = 0;
        setTimeout(() => {
          if (this.loadingEvent) {
            this.loading = true;
            setTimeout(() => {
              this.value = Math.floor(Math.random() * 40) + 10;
              this.queryAndIndeterminate();
            }, 400);
          }
        }, this.enterDelay);
      }
    },
    turnOffIndicator(): void {
      setTimeout(() => {
        this.value = 100;
        this.loading = false;
      }, this.exitDelay);
    },
    queryAndIndeterminate(): void {
      setTimeout(() => {
        if (this.loading) {
          this.value += ((100 - this.value) * Math.random()) / 6;
          this.queryAndIndeterminate();
        }
      }, this.animationSpeed);
    },
    initialLoadDone(): void {
      this.initialLoad = false;
    },
    displayLoadingError(error): void {
      this.error = error;
      this.errorLoading = true;
    },
    reloadPage(): void {
      // @ts-ignore
      this.$router.go();
    },
    dismissError(): void {
      this.errorLoading = false;
      this.$router.push({ name: 'accounts' });
    },
    logout(): void {
      AuthService.signOutUser();
    },
  },
});
